export const DONATION_FAQS =
  "https://help.showpass.com/hc/en-us/articles/360043062454";

export const SUPPORT_URL_ORGANIZER =
  "https://help.showpass.com/hc/en-us/categories/360001821154-Event-Organizers";
